import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { proApi, setProAuth } from "@/lib/proApi";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

const ProLogin = () => {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await proApi.post("/pro/login", { password });
      setProAuth(data.token, data.user);
      toast.success(`Willkommen, ${data.user.name}`);
      nav("/pro/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Anmeldung fehlgeschlagen"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#070707] flex items-center justify-center px-4" data-testid="pro-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="font-mono-lab text-[10px] tracking-[0.3em] text-[#ff0033] uppercase">// PRO PORTAL</span>
          <h1 className="font-heading text-4xl md:text-5xl uppercase tracking-tight text-white mt-3 leading-none">Kursübersicht<br />für Trainer</h1>
        </div>
        <form onSubmit={submit} className="bg-[#0F0F0F] border border-white/10 p-7 space-y-4" data-testid="pro-login-form">
          <div>
            <label className="font-mono-lab text-[10px] uppercase tracking-widest text-neutral-500">Zugangscode</label>
            <input data-testid="pro-password" type="password" required autoFocus value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full mt-1 bg-[#1A1A1A] border border-white/10 text-white p-3 text-center tracking-widest focus:border-[#ff0033] outline-none" />
          </div>
          <button data-testid="pro-login-submit" type="submit" disabled={loading}
            className="w-full bg-[#ff0033] text-white font-heading uppercase tracking-wider py-3.5 hover:bg-[#cc0029] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} /> Anmelden</>}
          </button>
          <p className="text-center text-neutral-600 text-xs pt-1">Code vergessen? Bitte den Administrator kontaktieren.</p>
        </form>
      </div>
    </div>
  );
};

export default ProLogin;
